import React from "react";
import { Route, Redirect } from "react-router-dom";

const AdminRoute = ({ component: C, props: cProps, ...rest }) =>
  <Route
    {...rest}
    render={props =>
      cProps.isAdmin
        ? <C {...props} {...cProps} />
        : <Redirect to={`/signin?redirect=${props.location.pathname}${props.location.search}`} />}
  />;

export default AdminRoute
